import { useNavigate, useParams } from "react-router-dom";
import { briefInfoType, userState } from "../../interface/MainInterface";
import { useEffect, useState } from "react";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { Box, Skeleton, Stack } from "@mui/material";
import CardBrief from "../aitb/articles/CardBrief";
import { useWindowSize } from "../../utils/useWindowSize";

interface propsType {
  userState: userState;
}

const unAuthAPI = new HttpUnAuthApi();

const KeywordGrouping = (props: propsType) => {
  const { sk } = useParams();
  const navigate = useNavigate();
  const windowSize = useWindowSize();
  
  const [isLoading, setIsLoading] = useState(false);
  const [openScrap, setOpenScrap] = useState(false); // 스트랩 버튼 제어용
  const [keyword, setKeyword] = useState("");
  const [scrapInfo, setScrapInfo] = useState<any>(null);
  const [briefList, setBriefList] = useState<any>([]);
  const [selectedBriefs, setSelectedBriefs] = useState<any>([]); // 브리프 선택 체크박스 스크랩용
  const [taggedBriefs, setTaggedBriefs] = useState<any>({});

  useEffect(() => {
    if (!props.userState.isAuth) window.location.href = "/";
    return () => {
      setIsLoading(false);
      setOpenScrap(false);
      setKeyword("");
      setSelectedBriefs([]);
      setTaggedBriefs({});
    };
  }, []);

  useEffect(() => {
    if (sk) get_scrap_info(sk);
  }, [sk]);

  useEffect(() => {
    if (selectedBriefs.length > 0) setOpenScrap(true);
    else setOpenScrap(false);
  }, [selectedBriefs]);

  const get_scrap_info = async (sk: string) => {
    const param: any = {
      command: "get_scrap_info",
      pk: `scrap_info#${props.userState.id}`,
      sk: sk,
      user_id: props.userState.id,
    };
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setScrapInfo(res.response.scrap_info);
      setBriefList(res.response.scrap_info.scrap_key_list);
      // console.log(res.response.scrap_info);
    }
  };

  const request_make_report = async () => {
    if (!scrapInfo) return;

    // 먼저 confirm을 처리하고, 이후에 비동기 코드 실행 (iOS 18.6.2 버전에서 동작하지 않아서 confirmed 처리)
    const confirmed = window.confirm("먼슬리 리포트를 발행하시겠습니까?");
    if (!confirmed) return;

    const temp = Object.entries(taggedBriefs).map(([key, values]) => {
      const briefKeyList = values as string[];
      
      if (values)
      return {
        key,
        list: briefKeyList.map((briefKey: string) => ({
          show_pk: briefKey.split("/")[0],
          sk: briefKey.split("/")[1]
        }))
      };
    });

    if (temp.length === 0) return;

    console.log("temp " ,temp);

    const param: any = {
      command: "request_make_report",
      scrap_info: scrapInfo,
      report_type: "keyword",
      source_list: temp,
      user_id: props.userState.id,
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      if (scrapInfo) {
        // 레포트 카운팅
        fncReportCount();
        // get_scrap_info(scrapInfo.pk, scrapInfo.sk);
        navigate('/reportList');
      }
      close();
    }
  };

  const fncReportCount = async () => {
    const param: any = {
      command: "update_report_count",
    };

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
    }
  };

  // 브리프 선택(체크박스)
  const selectBrief = (key: string) => {
    let temp = [...selectedBriefs];
    const index = temp.indexOf(key);
    if (index > -1) {
      temp.splice(index, 1);
    } else {
      temp.push(key);
    }
    setSelectedBriefs(temp);
  };

  const findTag = (key: string) => {
    // console.log("taggedBriefs ", taggedBriefs);
    if (!taggedBriefs) return;
    
    const item = Object.entries(taggedBriefs).find(([category, briefKeys]) => 
      (briefKeys as string).includes(key)
    );
    
    return item ? item[0] : null;
  };

  const removeTag = (briefKey: string, taggedKeyword: string) => {
    if (taggedBriefs.length === 0) return;
    if (taggedKeyword === "") return;

    setTaggedBriefs((prevState: any) => {
      const existBriefs = {...prevState};

      if (taggedKeyword) {
        existBriefs[taggedKeyword] = existBriefs[taggedKeyword].filter((brief: any) => brief !== briefKey);
        
        if (existBriefs[taggedKeyword].length === 0) {
          delete existBriefs[taggedKeyword];
        }
      }

      return existBriefs;
    });
  };

  // 브리프 바로가기
  const goBrief = (briefInfo: any) => {
    window.open(`/brief/${briefInfo.show_pk}/${briefInfo.sk}?list`);
  };

  const tag = () => {
    if (selectedBriefs.length < 0) return;
    if (keyword === "") return;

    setTaggedBriefs((prevState: any) => {
      let temp = [];
      const existBriefs = prevState[keyword] || [];
      
      for (const brief of selectedBriefs) {
        const index = existBriefs.indexOf(brief);
        if (index > -1) continue;
        else temp.push(brief);
      }
      const updateBriefs = [...existBriefs, ...temp];

      return {
        ...prevState,
        [keyword]: updateBriefs,
      };
    });

    setKeyword("");
    setSelectedBriefs([]);
  };

  const close = () => {
    setScrapInfo(null);
    setBriefList([]);
    setIsLoading(false);
    setOpenScrap(false);
    setKeyword("");
    setSelectedBriefs([]);
    setTaggedBriefs({});
  };

  return (
    <>
      <section id="commWrap">
        <article className="article-01">
          <div className="article-tit ta-c">
            {`리포트 발행을 위해`}
            <br /><span className="highlighter">{`브리프를 선택`}</span>
            {` 하고 `} 
            {windowSize.width <= 1023 && <br />}
            <span className="highlighter">{`주제를 생성`}</span>
            {`해보세요`}
            {/* <span className="highlighter">{`${resultCount}건`}</span> */}
          </div>
        </article>
        <div className={openScrap ? "grp-btn-wrap btn-binder-open" : "grp-btn-wrap btn-binder-close"}>
          { windowSize.width > 1023 ? (
            <div className="group-brief">
              <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <span>키워드 설정</span>
                <button
                  className="scrap-close"
                  onClick={() => {
                    setSelectedBriefs([]);
                  }}
                ></button>
              </div>
              <div style={{ display: "flex", flexDirection: "column" ,gap: "10px" }}>
                <p style={{ fontSize: "14px" }}>선택한 기사들을 그룹화할 주제를 입력하고 AI 레포트를 발행해보세요.</p>
                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "8px" }}>
                  <input
                    className="keyword"
                    type="text"
                    placeholder="주제 입력"
                    value={keyword}
                    onChange={(e) => {
                      setKeyword(e.target.value);
                    }}
                  />
                  <button
                    onClick={tag}
                    style={{ width: "222px", backgroundColor: "#D0FF00", borderRadius: "34px", fontWeight: 700, fontSize: "14px"}}
                  >
                    입력한 주제로 생성할게요
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="group-brief">
              <div>
                <span>키워드 설정</span>
                <p style={{ fontSize: "13px", paddingTop: "8px" }}>선택한 기사들을 그룹화할 키워드를 입력하고 AI 레포트를 발행해보세요.</p>
              </div>
              <input
                className="keyword"
                type="text"
                placeholder="키워드 입력"
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
              />
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "8px", paddingTop: "24px", height: "60px" }}>
                  <button
                    onClick={tag}
                    style={{ flex: 26, backgroundColor: "#D0FF00", borderRadius: "51px", fontWeight: 700, fontSize: "16px"}}
                  >
                    입력한 키워드로 분류할게요
                  </button>
                  <button
                    onClick={() => {
                      setSelectedBriefs([]);
                    }}
                    style={{ flex: 11, backgroundColor: "#B3B3B3", borderRadius: "51px", fontWeight: 700, fontSize: "16px"}}
                  >
                    닫기
                  </button>
                </div>
              </div>
            </div>
          )}
          
        </div>
        <article className="article-02">
          <div className="brief-list-wrap">
            <div className="brief-list">
              <div className="brief-cont">
                <div className="main-brief" style={{ marginBottom: "0px" }}>
                  <dl>
                    <dd>
                      {isLoading && briefList.length < 1
                        ? [...Array(9)].map((value: any, index) => (
                          <div key={`card-skeleton-${index}`} className="brief-box one-third">
                            <Skeleton
                              key={`brief-${index}`}
                              variant="rounded"
                              width={"100%"}
                              height={"220px"}
                              sx={{ borderRadius: "30px", mb: "32px" }}
                            />
                          </div>
                        ))
                        : 
                        // taggedBriefs.length > 0 &&
                        //   taggedBriefs.map((data: briefInfoType, ))
                        
                          briefList.length > 0 &&
                          briefList.map((data: briefInfoType, index: number) => (
                            <CardBrief
                              key={`brief-info-${index}`}
                              index={index}
                              briefInfo={data}
                              selectedKeywords={null}
                              taggedKeywords={findTag(`${data.show_pk}/${data.sk}`)}
                              checked={selectedBriefs.indexOf(`${data.show_pk}/${data.sk}`) > -1}
                              callback={(payload: any) => {
                                if (payload.command === "selectBrief") {
                                  selectBrief(payload.key);
                                } else if (payload.command === "goBrief") {
                                  // props.setNeedRefresh(false); //브리프 상세보기 클릭시 다시 목록으로 돌아올때 브리프 리스트를 재조회하지 않기 위함
                                  goBrief(payload.briefInfo);
                                } else if (payload.command === "removeTag") {
                                  removeTag(payload.key, payload.keyword);
                                }
                              }}
                              queryText={""}
                            />
                        ))
                      }
                      {/* 마지막 CSS 위치 이상한 부분 교정     */}
                      {briefList.length % 3 === 2 && <Box sx={{ width: "31.7%" }}></Box>}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          {/* footer */}
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
            {scrapInfo && (scrapInfo.scrap_status === undefined || scrapInfo.scrap_status === null) && (
              <Box
                sx={{ width: "100%", display: "flex", justifyContent: "center", p: "24px 16px 24px 16px" }}
                className={Object.keys(taggedBriefs).length === 0 ? "btn-make-monthly-report-ing" : "btn-make-monthly-report"}
              >
                <button
                  onClick={() => {
                    if (Object.keys(taggedBriefs).length === 0) return;
                    request_make_report();
                  }}
                >
                  <span style={{ fontWeight: 700, fontSize: "16px" }}>발행하기</span>
                </button>
              </Box>
            )}
            {scrapInfo?.scrap_status === "REQUEST_REPORT" && (
              <Box
                sx={{ width: "100%", display: "flex", justifyContent: "center", p: "24px 16px 24px 16px" }}
                className={"btn-make-monthly-report-ing"}
              >
                <button onClick={() => {}}>
                  <span>리포트 생성중...</span>
                </button>
              </Box>
            )}
          </Box>
        </article>
      </section>
    </>
  )
}

export default KeywordGrouping;